import { createCanBoundTo } from '@casl/react';
import ability from 'services/authorization.service';

export default createCanBoundTo(ability);
